import { EStatusCheck } from '../../enums/EStatusCheck'

export interface IWebsite {
  id: string;
  name: string;
  url: string;
  endpoint: string;
  SmsShortName: string;
  statusChecks: IStatusCheck[];
  enabled: boolean;
}

export interface IWebsiteGroupedStats {
  id: string;
  name: string;
  url: string;
  enabled: boolean;
  groupedStatusChecks: Record<string, IStatusCheck[]>
}

export interface IStatusCheck {
  id: string;
  websiteId: string;
  dateCreated: Date;
  status: EStatusCheck;
  message: string;
}

export class WebsiteFormValues {
  name: string = "";
  url: string = "";
  endpoint: string = "";
  smsShortName: string = "";
  enabled: boolean = false;
  constructor(init?: IWebsite) {
    Object.assign(this, init);
  }
}

export type WebsiteFormValuesWithId = {
  id: string;
  values: WebsiteFormValues;
}
